import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { EventRounded, CheckCircle, Cancel, DomainVerificationRounded } from '@mui/icons-material'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'
import { useAppSelector } from '../../../../redux/store'
import { Stack } from '@mui/system'
import {
  selectTotalActiveEvents,
  selectTotalCompletedEvents,
  selectTotalNotActiveEvents,
  selectTotalEvents,
} from '../../../../redux/reports/event/selector'

const EventReportCard = () => {
  const totalEvents = useAppSelector(selectTotalEvents)
  const active = useAppSelector(selectTotalActiveEvents)
  const nonActive = useAppSelector(selectTotalNotActiveEvents)
  const completed = useAppSelector(selectTotalCompletedEvents)

  const attendanceData = [
    {
      label: 'Total Events',
      value: totalEvents || 0,
      background: 'linear-gradient(90deg, #1CB5E0 0%, #000851 100%)', // Blue gradient
      Icon: EventRounded,
    },
    {
      label: 'Active Events',
      value: active || 0,
      background: 'linear-gradient(90deg, #9ebd13 0%, #008552 100%)', // Green gradient
      Icon: CheckCircle,
    },
    {
      label: 'Inactive Events',
      value: nonActive || 0,
      background: 'linear-gradient(90deg, #d53369 0%, #daae51 100%)', // Red gradient
      Icon: Cancel,
    },
    {
      label: 'Completed Events',
      value: completed || 0,
      background: 'linear-gradient(90deg, #FDBB2D 0%, #3A1C71 100%)', // Yellow gradient
      Icon: DomainVerificationRounded,
    },
  ]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {attendanceData.map((item) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
            <Card
              sx={{
                background: item.background,
                color: 'white',
                borderRadius: fontSizes.size12,
                padding: 0,
              }}
            >
              <CardContent>
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                  <Typography
                    sx={{
                      fontSize: { xs: fontSizes.size12, md: fontSizes.size16 },
                      fontWeight: fontWeights[500],
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  >
                    {item.label}
                  </Typography>

                  <item.Icon
                    sx={{
                      fontSize: {
                        xs: fontSizes.size28,
                        md: fontSizes.size36,
                      },
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  />
                </Box>
                <Stack direction='row' alignItems='center' spacing={1}>
                  <Typography
                    sx={{
                      fontSize: { xs: fontSizes.size16, md: fontSizes.size32 },
                      fontWeight: fontWeights[500],
                      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    }}
                  >
                    {item.value.toLocaleString()}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default EventReportCard
